import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useStliteKernel, useStliteKernelIfAvailable, } from "@stlite/kernel/contexts";
import { extractCustomComponentPath, getParentPath } from "./url";
import { manipulateIFrameDocument } from "./iframe-manipulation";
const InnerIFrame = React.forwardRef(({ src: path, IframeComponent, ...props }, ref) => {
    const kernel = useStliteKernel();
    const [srcdoc, setSrcdoc] = useState();
    useEffect(() => {
        if (kernel == null) {
            return;
        }
        if (!path.startsWith("/component")) {
            return;
        }
        let released = false;
        kernel
            .sendHttpRequest({
            method: "GET",
            path: path,
            headers: {},
            body: "",
        })
            .then(({ statusCode, headers, body }) => {
            if (released) {
                return;
            }
            if (statusCode !== 200) {
                return;
            }
            const type = headers.get("Content-Type");
            const blob = new Blob([body], type ? { type } : undefined);
            blob.text().then((text) => {
                if (released) {
                    return;
                }
                setSrcdoc(text);
            });
        });
        return () => {
            released = true;
        };
    }, [kernel, path]);
    const handleIFrameLoad = useCallback((ev) => {
        const iframe = ev.target;
        const document = iframe.contentWindow?.document;
        if (document == null) {
            console.warn("document not found in iframe");
            return;
        }
        manipulateIFrameDocument(kernel, document, getParentPath(path));
    }, [kernel, path]);
    return (_jsx(IframeComponent, { ...props, srcDoc: srcdoc, onLoad: handleIFrameLoad, ref: ref }));
});
InnerIFrame.displayName = "InnerIFrame";
const CustomComponentIFrame = React.forwardRef((props, ref) => {
    const kernel = useStliteKernelIfAvailable();
    const path = useMemo(() => kernel == null
        ? null
        : extractCustomComponentPath(kernel.basePath, props.src), [kernel, props.src]);
    if (kernel == null) {
        // Server-backed app (no kernel): the iframe src is directly servable, so
        // render the wrapped component untouched.
        const { IframeComponent, ...rest } = props;
        return _jsx(IframeComponent, { ...rest, ref: ref });
    }
    if (path == null) {
        return _jsx("iframe", { ...props, ref: ref });
    }
    return _jsx(InnerIFrame, { ...props, src: path, ref: ref });
});
CustomComponentIFrame.displayName = "StliteCustomComponentIFrame";
export default CustomComponentIFrame;
//# sourceMappingURL=index.js.map